<script setup lang="ts">
import SendcryptLogo from "@/components/SendcryptLogo.vue";

interface Props {
    errorMessages?: string
    status?: string
    loading?: boolean
}

withDefaults(defineProps<Props>(), {
    errorMessages: undefined,
    status: undefined,
    loading: false,
})
const emit = defineEmits(['submit'])

const submit = () => {
    emit('submit')
}
</script>

<template>
    <v-card
        variant="flat"
        color="transparent"
    >
        <div class="text-center">
            <sendcrypt-logo width="72" />
        </div>
        <v-card-title class="font-weight-regular text-h5 text-center mb-3 px-0 text-pre-line">
            <slot name="title" />
        </v-card-title>
        <v-alert
            v-if="errorMessages"
            type="error"
            class="px-5 py-5 mb-5 bg-red-lighten-5"
            dense
            outlined
            variant="outlined"
            :icon="false"
        >
            <div class="text-black text-body-2">
                {{ errorMessages }}
            </div>
        </v-alert>
        <v-alert
            v-if="status"
            type="success"
            class="px-5 py-4 mb-5 bg-green-lighten-5"
            dense
            outlined
            variant="outlined"
            :icon="false"
        >
            <div class="text-black text-body-2">
                {{ status }}
            </div>
        </v-alert>
        <slot name="prepend" />
        <v-card-text
            class="rounded-lg pa-5 bg-grey-lighten-4"
            style="border: 1px solid hsla(210,18%,87%,1) !important"
        >
            <v-form @submit.prevent="submit">
                <slot />
                <submit-btn
                    class="mt-5"
                    :block="true"
                    :loading="loading"
                    type="submit"
                >
                    <slot name="submit">
                        Submit
                    </slot>
                </submit-btn>
            </v-form>
            <slot name="hint" />
        </v-card-text>
        <slot name="append" />
    </v-card>
</template>

<style scoped>

</style>
